import React from "react";
import GroupStatus from "Components/IconDropdown/Cross_Tick/GroupStatus";
import { Card, CardBody } from "reactstrap";
import ReactTableGeneric from "../../../Components/ReactTableGeneric";
import { useScheduledEmailJobs, useToggleEmail } from "Api/Admin/GeneralSetting";
import { toast } from "react-toastify";

const ScheduledEmails = () => {



    const columns = React.useMemo(
        () => [
            {
                header: () => 'Rol',
                accessorKey: 'role',
                // 1. Pass the size metadata out to TanStack's shared access layer
                size: 50,
                minSize: 50,
                maxSize: 60,
            },
            {
                header: () => 'Proces',
                accessorKey: 'name',

            },
            {
                header: () => 'Trigger / toelichting',
                accessorKey: 'process',

            },
            {
                header: () => "Ingeschakeld",
                accessorKey: "is_enabled",


                cell: ({ row }) => {
                    const item = row.original;

                    return (
                        <div className="cursor-pointer d-flex justify-content-center">
                            <GroupStatus
                                data={item.is_enabled ? 1 : 0}
                                iconChangeHandler={() => handleToggle(item)}
                            />
                        </div>
                    );
                },
            },

        ],
        []
    );
   const {
        trigger: toggleEmail,
        isMutating: toggleLoading,
    } = useToggleEmail();

    const handleToggle = async (item) => {
        const newEnabled = !item.is_enabled;


        try {
            const response = await toggleEmail({
                data: {
                    command: item.command,
                    enabled: newEnabled,
                },
            });


            if (response?.status) {
                toast.success("Scheduled job updated successfully.");

                // Re-fetch GET API
                await mutateScheduledEmailJobs();
            }
        } catch (error) {
            console.error("========== TOGGLE ERROR ==========");
            console.error(error);

            toast.error("Could not update scheduled job.");
        }
    };

    const {
        data: scheduledEmailResponse,
        mutate: mutateScheduledEmailJobs
    } = useScheduledEmailJobs();


    return (

        <Card className="main-card general-setting">
            <CardBody>
                <p className="py-2 mb-3" style={{ fontWeight: '500'}}> Scheduled e-mailprocessen</p>
                <ReactTableGeneric
                    data={scheduledEmailResponse?.data || []}
                    columns={columns}
                    tableClassName="mb-0 table table-borderless table-sm table-hover tb-links"
                    filters={{
                        search: false,
                        pagination: false,
                        sorting: false
                    }}
                    count={scheduledEmailResponse?.data?.length || 0}
                />



            </CardBody>
        </Card>

    )
}

export default ScheduledEmails